import { render, staticRenderFns } from "./edit-measurements.vue?vue&type=template&id=58b38a10&scoped=true&"
import script from "./edit-measurements.vue?vue&type=script&lang=ts&"
export * from "./edit-measurements.vue?vue&type=script&lang=ts&"
import style0 from "./edit-measurements.vue?vue&type=style&index=0&id=58b38a10&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b38a10",
  null
  
)

export default component.exports